module.exports = __webpack_public_path__ + "img/hero_dois.bb797700.jpg";